import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';
import { PageDefault } from '../PageDefault'; 

@Component({
    selector: 'deposit-search',
    templateUrl: 'depositsearch.html' 
})

export class Depositsearch {
    start = PageDefault.startDate();
    end = PageDefault.endDate();
    PageIndex=1;


    tracks = {};
    constructor(private viewCtrl: ViewController, private navpar: NavParams) {
        this.start = navpar.data.startDate != undefined ? navpar.data.startDate : PageDefault.startDate();
        this.end = navpar.data.endDate != undefined ? navpar.data.endDate : PageDefault.endDate();
        this.PageIndex=1;

    }


    //查询条件
    applyFilters() {
        this.tracks["startDate"] = this.start;
        this.tracks["endDate"] = this.end;
        this.tracks["pageIndex"]=this.PageIndex;
        this.dismiss(this.tracks)
    }
        
    
    //关闭
    dismiss(data?: any) {
        this.viewCtrl.dismiss(data);
    }



}




// WEBPACK FOOTER //
// ./src/pages/deposit-record/depositsearch.ts